import { HttpParams } from '@angular/common/http';

import { ITableFilter } from 'v2/modules/shared/interfaces/table.interface';

//

export function createHttpParamsFromTableFilter(filter :ITableFilter) :HttpParams {
  let params = new HttpParams();

  // Handle column filters
  filter.columnFilters?.forEach((columnFilter) => {
    if (columnFilter.value !== undefined) {
      let filterValue = columnFilter.value;
      // If the value is an array, convert it to a comma-separated string
      if (Array.isArray(filterValue)) {
        filterValue = filterValue.join(',');
      }
      // Construct the filter key with optional comparison operator
      const filterKey = columnFilter.comparison
        ? `${columnFilter.column}[${columnFilter.comparison}]`
        : `${columnFilter.column}[eq]`;
      params = params.set(filterKey, filterValue.toString());
    }
  });

  // Handle global filter
  if (filter.globalFilter) {
    params = params.set('globalFilter', filter.globalFilter);
  }

  // Handle pagination
  if (filter.pagination) {
    params = params.set('page', filter.pagination.page.toString());
    params = params.set('pageSize', filter.pagination.pageSize.toString());
  }

  // Handle sorting
  if (filter.sort) {
    const sortValue = `${filter.sort.column},${filter.sort.direction}`;
    params = params.set('sort', sortValue);
  }

  // Handle relations
  if (filter.relations) {
    params = params.set('relations', filter.relations.join('|'));
  }

  return params;
}
